const PREFIX = "/garage/";
export const GET_GARAGE_INFO_URL = PREFIX + "garage-info/get";
export const CHANGE_GARAGE_EMAIL_URL = PREFIX + "change-email";
export const UPDATE_WORKSHOP_ID = PREFIX + "update-workshop-id";
export const VERIFY_WORKSHOP_ID_URL = PREFIX + "verify-workshop-id";
